import Vue from "vue";
import VueCookies from "vue-cookies";


const USER_DATA = () => {
  return {
    account: "",
    authToken: "",
    belongcompany: "",
    belongcompany_cd: "",
    grade: "",
    name: "",
    service: "",
  };
};

const mutations = {
  drawer(state, payload) {
    state.drawer = payload;
  },
  sessionId(state, payload) {
    state.sessionId = payload;
  },
  login(state, payload) {
    // 로그인관련 데이터 저장
    state.isLogin = true;
    state.userInfo = { ...payload };

    // console.log("login mutation")
    // console.log(payload)
    // login 성공, token 을 설정 
    Vue.axios.defaults.headers.common['authorization'] = `Bearer ${payload.auth_token}`;
    // cookie 설정
    VueCookies.set("auth_token" ,payload.auth_token,"30d")
    VueCookies.set("account" ,payload.account,"30d")
    VueCookies.set("name" ,payload.name,"30d")
    VueCookies.set("grade" ,payload.grade,"30d")
   
  },
  logout(state) {

    // console.log("will remove cookie")
    Vue.axios.defaults.headers.common['authorization'] = null;
    VueCookies.remove("auth_token")
    VueCookies.remove("account")
    VueCookies.remove("name")
    VueCookies.remove("grade")
    VueCookies.remove("menu_list")


    state.isLogin = false;
    state.userInfo = USER_DATA(); // state 사용자 데이터 초기화
  },
  showAlert(state, payload) {
    state.showAlert = payload;
  },
  setAlert(state, { title, text }) {
    state.alertText = text;
    state.alertTitle = title;
  },
  // == company ==
  comboCompanies(state, payload) {
    state.companyInfo = payload;
  },
  // == farm ==
  comboBuildings(state, payload) {
    state.buildingInfo = payload;
  },
  comboFarms(state, payload) {
    state.farmInfo = payload;
  },
  
  setFarmInfo(state, farm) {
    state.farmInfo = farm
    localStorage.setItem('farmInfo', JSON.stringify(farm))
  },
  
  clearFarmInfo(state) {
    state.farmInfo = {}
    localStorage.removeItem('farmInfo')
  },

  use_selected_org_info(state, payload) {
    state.use_selected_org_info = payload
  },
  selected_org_info(state, payload) {
    state.selected_org_info = payload
    // console.log("TEST vuex state : ", state.selected_org_info)
  },
  resMessage(state, payload) {
    state.resMessage = payload
    // console.log("TEST vuex state : ", state.resMessage)
  },
  showMilk(state, payload) {
    state.showMilk = payload
    // console.log("TEST vuex state : ", state.showMilk)
  },

  // 사육
  hideGrow(state, payload) {
    state.hideGrow = payload
    // console.log("TEST vuex state : ", state.hideGrow)
  },
};
export default mutations;
